import { render } from "./BoldText.vue?vue&type=template&id=521fec58&scoped=true"
import script from "./BoldText.vue?vue&type=script&lang=js"
export * from "./BoldText.vue?vue&type=script&lang=js"

import "./BoldText.vue?vue&type=style&index=0&id=521fec58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521fec58"]])

export default __exports__